/* eslint-disable react/prop-types */
import React from 'react';

import { Icon } from '@qality/common-components/src/atoms/Icon';
import { Link } from '@qality/common-components/src/atoms/Link';
import { FieldError } from '@qality/common-components/src/molecules/final-form/FieldError';
import { StorageOfUniqueServices } from '@qality/common-service';

import { NO_ISSUE_TYPE } from '../UploadFiles.validation';

export const ProjectSelectErrorView = ({
  meta,
  handleGoToConfigurationLink,
}) => {
  const ICON_PATH =
    StorageOfUniqueServices.get('URLService').getQAlityIssueIcon();

  return (
    <>
      {meta.touched && meta.error && meta.error === NO_ISSUE_TYPE ? (
        <p>
          <Icon src={ICON_PATH} alt='Icon' />
          QAlity Test issue type is not configured for the selected project.
          <Link onClick={handleGoToConfigurationLink}> Configure it</Link> or
          choose another project
        </p>
      ) : (
        <FieldError name='project' />
      )}
    </>
  );
};
